import { useState } from "react";
import { observer } from "mobx-react";
import { CloseSquare, Trash } from "iconsax-react";
import { Box, Dialog, DialogContent, DialogTitle, DialogActions, IconButton, Typography, MenuItem, ListItemText, ListItemIcon } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import styles from '../my-data.module.scss';

const DeleteLabelModal = observer(({ label, category, uiStore, updateData, btnStyle = 'fullBtn' }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const confirm = async () => {
        setLoading(true);
        const data = await uiStore.deleteLabel(label._id, category.name);
        updateData(data);
        setLoading(false);
        setShow(false);
    }

    return (
        <>
            {btnStyle === 'fullBtn' &&
                <MenuItem onClick={() => setShow(true)}>
                    <ListItemIcon>
                        <Trash
                            size="24"
                            variant="Bulk"
                        />
                    </ListItemIcon>
                    <ListItemText primaryTypographyProps={{ fontSize: '14px' }}>Delete</ListItemText>
                </MenuItem>
            }

            {btnStyle === 'iconOnly' &&
                <IconButton
                    onClick={() => setShow(true)}
                    sx={{ ml: 1, mt: 2, height: 'fit-content' }}
                >
                    <Trash
                        size="24"
                        variant="Bulk"
                    />
                </IconButton>
            }

            <Dialog open={show} onClose={() => setShow(false)}
                PaperProps={{ sx: { padding: '20px', textAlign: 'center' }, variant: 'round' }}
            >
                <DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={() => setShow(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseSquare
                            size="30"
                            variant="Bulk"
                        />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ textAlign: 'center' }}>
                    <Box className={styles.deleteIconContainer}>
                        <Trash
                            size="30"
                            variant="Bulk"
                        />
                    </Box>
                    <Typography fontWeight={600}>Delete Infomation</Typography>
                    <Typography color='#888888'>Are you sure you want to delete {label.name} information?</Typography>

                </DialogContent>
                <DialogActions>
                    <LoadingButton loading={!!loading} onClick={() => setShow(false)} variant="contained" color="lightblue">
                        Cancel
                    </LoadingButton>
                    <LoadingButton loading={!!loading} onClick={confirm} variant="contained" color="error">
                        Delete
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </ >
    );
});

export default DeleteLabelModal;
